class LowStockEmailNotificationsController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'IntegrationRepository'
		'ToastService'
		'shops'
		'UserInformation'

	integrationId: 'low_stock_email_notifications'

	initialize: ->
		@defaultEmail = @UserInformation.getMasterUser().email
		@configuration.stock_margin ?= 0

		if !@isConnected()
			@configuration.default_email = @defaultEmail

		@resetShopEmailState(@configuration.emails)

	save: ->
		if _.isEmpty(@configuration.default_email)
			@configuration.default_email = null

		shopEmails = _.filter(
			@shopEmailState,
			(item) -> !_.isEmpty(item.email)
		)

		@configuration.emails = _.map(
			shopEmails,
			(item) -> {shop_id: item.id, email: item.email},
		)

		super(@configuration)
			.then (response) =>
				@configuration = response.data

	resetShopEmailState: (shopEmails = []) ->
		shopEmailMap = _.indexBy(shopEmails, 'shop_id')

		@shopEmailState = _.map(
			@shops,
			(item) -> {
				id: item.id,
				name: item.name,
				email: shopEmailMap[item.id]?.email,
			},
		)

	afterDisconnect: ->
		@configuration.stock_margin = 0
		@configuration.default_email = @defaultEmail
		@resetShopEmailState()
